import { IonContent } from "@ionic/react";
import { Markdown } from "../components/Markdown";
import styled from "styled-components";
import { useTranslate } from "../contexts/translate";
import { Background } from "../components/ui/Background";
import { Subheader } from "../components/ui/Subheader";
import { BigButton } from "../components/ui/BigButton";
import { PaperBackground } from "../components/ui/PaperBackground";
import { Header } from "../components/ui/Header";

const mdFr = `
  ## How to read a summary card
  <Hedgerow summary card with bullets - TBD>

  **1- Summary card type and reference number.** Most of the special rules used in a scenario briefing are summed up using their name, as well as their type and reference number (e.g. Mountain - Terrain 30, Cavalry - Troops 8...).
  
  **2-** (On terrain summary cards only) **Frequent special rules** that apply to terrain, indicated by the following icons:

  ![IC](Terrains Cards/Icones/stop.png)
  A unit that enters this terrain hex must stop and may move no further on that turn.
  
  ![IC](Terrains Cards/Icones/noatt.png)
  A unit that enters this terrain hex cannot battle that turn.
  
  ![IC](Terrains Cards/Icones/los.png)
  This terrain hex blocks line of sight.
  
  ![IC](Terrains Cards/Icones/flag.png)
  A unit on this terrain hex may ignore 1 flag each time they are the target of an attack, even on the same turn.
  
  **3- Additional special rules**, if any.
  
  **4-** (On terrain summary cards only) **Terrain protections.** This indicates the battle dice reductions for the pictured unit types when they attack an enemy unit standing on this terrain. 
  ![def](Terrains Cards/Def/inf-1.png) ![def](Terrains Cards/Def/arm-2.png)
  In this example, infantry roll 1 less die and armor roll 2 less dice when attacking a unit standing on a hedgerow hex.
  
  **Note:** sometimes, frequent special rules and terrain protection icons may be marked by one or two asterisks.
  ![def](Terrains Cards/Def/inf-2_b.png) ![IC](Terrains Cards/Icones/los_c.png)
  This means the rules apply, but under certain conditions, or with some amendments, which are detailed in the additional special rules section of the card.
`;

const Container = styled.div`
  width: 100%;
  padding: calc(var(--u) * 3);
  color: black;
  max-width: 600px;
`;

const Credits: React.FC = () => {
  const { translate } = useTranslate();

  return (
    <>
      <Header size="small" shouldHide />
      <IonContent>
        <Background background="cards">
          <Subheader>
            <BigButton
              icon="cards"
              label={translate("screens.credits.title")}
              to=""
              mode="title"
            />
          </Subheader>
          <IonContent style={{ "--background": "transparent" }}>
            <PaperBackground>
              <Container>
                <Markdown md={mdFr} />
              </Container>
            </PaperBackground>
          </IonContent>
        </Background>
      </IonContent>
    </>
  );
};

export default Credits;
